import { v4 as uuidv4 } from "uuid";
import { Maybe } from "../../../utilities/fp";

export const NodeId = {
  default: "0",
  make: (id) => Maybe.of(id).map(String).orElse(uuidv4()).value(),
  isDefault: (id) => id === "0",
  same: (id1, id2) => String(id1) === String(id2),
};
